import { render, staticRenderFns } from "./QsTips.vue?vue&type=template&id=52aa76c6&scoped=true&"
import script from "./QsTips.vue?vue&type=script&lang=js&"
export * from "./QsTips.vue?vue&type=script&lang=js&"
import style0 from "./QsTips.vue?vue&type=style&index=0&id=52aa76c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa76c6",
  null
  
)

export default component.exports